// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + "8484d84f29d213142a6e" + "-chunk.js";
};